// frontend/routes.tsx
import { createBrowserRouter, Link, RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/modules/auth';
import MainLayout from './components/layout/MainLayout';
import LicenseSetupView from '@/modules/license-setup/views/LicenseSetupView';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';

const FallbackLoginPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen p-6">
      <div className="w-full max-w-md rounded-lg border p-6">
        <h1 className="text-xl font-semibold">Login</h1>
        <p className="mt-2 text-sm opacity-80">
          The authentication module is currently disabled.
        </p>
        <div className="mt-4">
          <Link className="underline" to="/">
            Back Home
          </Link>
        </div>
      </div>
    </div>
  );
};

const getRouteStructure = (routes: RouteObject[]): any[] => {
  return routes.map(route => ({
    path: route.path,
    children: route.children ? getRouteStructure(route.children) : undefined,
    index: route.index,
  }));
};

export const createAppRouter = (moduleRoutes: RouteObject[]) => {
  const moduleLoginRoutes = moduleRoutes.filter(route => route.path === '/login');
  const isAuthEnabled = moduleLoginRoutes.length > 0;
  const loginRoutes: RouteObject[] =
    moduleLoginRoutes.length > 0
      ? moduleLoginRoutes
      : [
          {
            path: '/login',
            element: <FallbackLoginPage />,
          },
        ];

  const routes: RouteObject[] = [
    // Login routes (outside of main layout and protection)
    ...loginRoutes,
    {
      path: '/license/setup',
      element: <LicenseSetupView />,
    },
    {
      path: '/license/status',
      element: <LicenseSetupView />,
    },
    // Main application routes (with layout and authentication protection)
    {
      path: '/',
      element: (
        isAuthEnabled ? (
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        ) : (
          <MainLayout />
        )
      ),
      children: [
        {
          index: true,
          element: <HomePage />,
        },
        // Spread other module routes (excluding login)
        ...moduleRoutes.filter(route => route.path !== '/login'),
        {
          path: '*',
          element: <NotFoundPage />,
        },
      ],
    },
  ];

  console.log('Route structure:', getRouteStructure(routes));
  return createBrowserRouter(routes);
};
